import { RootState } from "store";

export const clientSelector = (state: RootState) => state.client.client;

export const loadingClientSelector = (state: RootState) =>
  state.client.loadingClient;

export const loadClientErrorSelector = (state: RootState) =>
  state.client.loadClientError;
